import Link from 'next/link';
import Image from 'next/image';

export function MainFooter() {
  return (
    <footer className="border-t border-border/40 bg-background/80 py-6 backdrop-blur-sm">
      <div className="container flex flex-col items-center justify-between gap-4 md:flex-row">
        <div className="flex items-center space-x-2">
          <Image src="/images/favicon.png" alt="Logo WebSite App" width={24} height={24} className="h-6 w-6" />
          <span className="font-headline font-bold">WebSite App</span>
        </div>
        <p className="text-sm text-foreground/60">
          © {new Date().getFullYear()} WebSite App. Todos os direitos reservados.
        </p>
        <nav className="flex gap-4">
          <Link href="/privacy-policy" className="text-sm text-foreground/60 hover:text-foreground/80">
            Política de Privacidade
          </Link>
          <Link href="/terms-of-service" className="text-sm text-foreground/60 hover:text-foreground/80">
            Termos de Serviço
          </Link>
        </nav>
      </div>
    </footer>
  );
}
